<style>
.lbl-title {
  color: red;
  font-weight: bold;
  font-size: 20px;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Mis Cuentas</b-card-header>

      <b-card-body v-if="MostrarMensajeResuesta">
        <div class="row">
          <div class="col-md-12 text-center">
            <base-alert :type="resultadoRespuesta.Tipo">
              <span class="alert-inner--icon" style="font-size: 60px;">
                <i :class="resultadoRespuesta.Icono"></i>
              </span>
              <br />
              <span class="alert-inner--text" v-html="resultadoRespuesta.Texto"></span>
              <br />
              <span
                class="alert-inner--text"
                v-html="resultadoRespuesta.TextoSecundario"
                style="font-size: 13px;"
              ></span>
            </base-alert>
          </div>
        </div>
        <div class="row" style="margin-top: 30px">
          <div class="col-md-12 text-left">
            <b-button class="btn btn-danger" @click="GoBack()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
          </div>
        </div>
      </b-card-body>
      <b-card-body v-else>
        <div class="col-md-12 text-center lbl-title">Identificá la cuenta</div>
        <div
          class="col-md-12 text-center"
          style="padding-bottom:30px;font-size:13px"
        >Podés renombrar la cuenta agendada</div>
        <div class="col-md-12 text-center">
          <img src="img/icons/Edit-2x.png" />
        </div>
        <div class="row form-group" style="justify-content: center;padding-top:30px">
          <div class="col-md-4">
            <label>Descripción</label>
            <base-input v-model="AccountName" @keyup="DescriptionKeyUp()"></base-input>
          </div>
        </div>
        <div class="row form-group" style="justify-content: center;">
          <div class="col-md-4">
            CBU:
            <b>{{CBU}}</b>
          </div>
        </div>
        <div class="row form-group" style="justify-content: center;">
          <div class="col-md-4">
            Cuenta en:
            <b>{{PspName}}</b>
          </div>
        </div>
        <div class="row" style="padding-top: 30px">
          <div class="col-md-12 text-center">
            <base-button type="danger" size="md" @click="GoBack">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </base-button>
            <base-button
              type="success"
              size="md"
              @click="ConfirmEdit"
              :disabled="DisableConfirmEdit"
            >
              <i class="fa fa-check-circle fa-fw"></i>Aceptar
            </base-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import confirmHelpers from "@/helpers/confirmHelpers";
import axiosHelpers from "@/helpers/axiosHelpers";

export default {
  props: {
    EntityIDProp: Number
  },
  components: {},
  data() {
    return {
      Id: this.EntityIDProp,
      OriginalAccountName: "",
      DisableConfirmEdit: true,
      AccountName: "",
      CBU: "",
      PspName: "",
      MostrarMensajeResuesta: false,
      resultadoRespuesta: {
        Texto: "",
        TextoSecundario: "",
        Tipo: "",
        Icono: ""
      }
    };
  },
  methods: {
    GetAccountForEdition() {
      let context = this;
      axiosHelpers.axiosGet(
        "RecruitmentAccountsPsp/GetAccountPspForEdition",
        { EntityID: context.Id },
        this,
        function(data) {
          context.OriginalAccountName = data.ResponseVM.Item.AccountName;
          context.AccountName = data.ResponseVM.Item.AccountName;
          context.CBU = data.ResponseVM.Item.CVU_CBU;
          context.PspName = data.ResponseVM.Item.PspName;
        }
      );
    },
    DescriptionKeyUp() {
      let context = this;
      if (context.AccountName != context.OriginalAccountName) {
        context.DisableConfirmEdit = false;
      } else {
        context.DisableConfirmEdit = true;
      }
    },
    GoBack() {
      this.$router.push("miscuentas");
    },
    ConfirmEdit() {
      let context = this;

      confirmHelpers.showConfirm(
        "¿Querés renombrar la cuenta a " + context.AccountName + "?",
        context,
        function() {
          context.Edit();
        }
      );
    },
    Edit() {
      let context = this;

      axiosHelpers.axiosPostWithoutAlerts(
        "RecruitmentAccountsPsp/SaveAccountPspFromEdition",
        { EntityID: context.Id, Name: context.AccountName },
        context,
        function(data) {
          context.MostrarMensajeResuesta = true;
          if (data.ResponseVM.Success) {
            context.resultadoRespuesta = {
              Texto: "Operación realizada con éxito!",
              TextoSecundario: "Cuenta Editada",
              Tipo: "success",
              Icono: "fa fa-fw fa-check-circle"
            };
          } else {
            if (data.Alerts.length > 0) {
              context.resultadoRespuesta = {
                Texto: data.Alerts[0].Message,
                Tipo: "danger",
                Icono: "fa fa-fw fa-times-circle"
              };
            }
          }
        }
      );
    }
  },
  computed: {},
  beforeMount: function() {
    this.GetAccountForEdition();
  }
};
</script>